import {
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import logo_2 from "../../assets/logo_2.webp";
import dollar from "../../assets/dollar.webp";
import jack from "../../assets/jack.webp";
import calender_board from "../../assets/calender_board.webp";
import useWindowDimensions from "../../utils/hooks/windowDimensions";
import { useNavigate } from "react-router-dom";
import Input from "../../component/common/Input";
import ButtonComp from "../../component/common/ButtonComp";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { getImageUrl } from "../../utils/imageUrl";
import { useDispatch, useSelector } from "react-redux";
import { asyncStatus } from "../../utils/asyncStatus";
import { get_services } from "../../services/services";
import { VscCalendar } from "react-icons/vsc";
import { themeOrange } from "../../utils/colorTheme";
import { FiTool } from "react-icons/fi";
import tools from "../../assets/tools.webp";
import dollar_hand from "../../assets/dollar_hand.webp";
import calendar from "../../assets/calendar.webp";
import CustomModal from "../../component/common/CustomModal/CustomModal";
import { RxCross2 } from "react-icons/rx";
import {
  cancelSubscriptionAsync,
  subscriptionAsync,
} from "../../services/SubscriptionService";
import {
  setCancelSubscriptionSatus,
  setSubscriptionSatus,
} from "../../store/slices/subscription_slice";
import { setJobsSteps } from "../../store/slices/ui_control_slice";
import { setJobsImages } from "../../store/slices/services_slice";
import { service_booking_keys, steps_constants } from "../../store/constants";

const Subscription = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const [isOpenModal, setIsOpenModal] = useState(false);

  const swiperRef = useRef(null);

  const { user } = useSelector((state) => state.userAuth);
  const { get_all_services_status, get_all_services_data } = useSelector(
    (state) => state.serviceManage
  );
  const { cancel_subscription_status } = useSelector(
    (state) => state.subscriptionSlice
  );

  const cancelSubscribeLoader =
    cancel_subscription_status === asyncStatus.LOADING;

  const getServiceLoader = get_all_services_status === asyncStatus.LOADING;

  const _goToPrevSlide = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const _goToNextSlide = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext();
    }
  };

  useEffect(() => {
    // Only fetch services if not already loaded to prevent rate limiting
    if (!get_all_services_data) {
      dispatch(get_services());
    }
  }, [dispatch, get_all_services_data]);

  const _handleClick = (item) => {
    navigate(`/service-details/${item}`);
    dispatch(setJobsSteps({ value: null }));
    localStorage.removeItem(steps_constants.JOBS_STEP);
    localStorage.removeItem(service_booking_keys.DATE);
    localStorage.removeItem(service_booking_keys.TIME);
    localStorage.removeItem(service_booking_keys.DESCRIPTION);
    localStorage.removeItem(service_booking_keys.LOCATION);
    localStorage.removeItem(service_booking_keys.PRICE);
    localStorage.removeItem(service_booking_keys.IMAGES);
  };

  const _handleCancel = () => {
    setIsOpenModal(!isOpenModal);
  };
  const _handleNavigateMemberShip = () => {
    navigate("/member-ship");
  };

  const _handleCancelSubscribe = () => {
    dispatch(cancelSubscriptionAsync());
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (cancel_subscription_status === asyncStatus.SUCCEEDED) {
      dispatch(setCancelSubscriptionSatus());
      setIsOpenModal(false);
      window.location.reload();
    }
  }, [cancel_subscription_status]);

  const memberShipCardData = [
    {
      icon: dollar_hand,
      title: "Save $25 on Every Completed Job",
      description: `Enjoy exclusive savings as a member! Get $25 off every job we complete for you, whether it's a small repair or a full remodel. Start saving on each project and make your home improvements more affordable.`,
    },
    {
      icon: tools,
      title: "Extended Warranty from 30 to 60 Days",
      description: `As a member, enjoy peace of mind with an extended warranty on all work performed. We double our standard warranty from 30 to 60 days, ensuring that any issues are covered and giving you confidence in the quality of our services.`,
    },
    {
      icon: calendar,
      title: "Cancel Membership Anytime (No Fees or Penalties)",
      description: `Our membership is flexible and hassle-free. If you ever need to cancel, you can do so at any time with no cancellation fees or penalties. We’re committed to providing value on your terms.`,
    },
  ];

  return (
    <Container maxWidth={"100%"} sx={{ backgroundColor: "#FAFAFA" }}>
      <Stack>
        <Typography className="mainHeading">Membership</Typography>
        <hr color={"#D1D1D1"} />
      </Stack>

      {/* MEMBERSHIP -----!> */}
      <Stack my={5}>
        <Box
          sx={{
            borderRadius: "20px",
            overflow: "hidden",
            background: "linear-gradient(135deg, #162f77 0%, #031444 100%)",
            boxShadow: "0 20px 60px rgba(22, 47, 119, 0.35)",
          }}
        >
          {/* Top accent bar */}
          <Box
            sx={{
              height: "4px",
              background: "linear-gradient(90deg, #F15A24, #ff8c5a)",
            }}
          />

          <Grid container>
            {/* Left — Branding & Price */}
            <Grid
              item
              xs={12}
              md={4}
              sx={{
                borderRight: { md: "1px solid rgba(255,255,255,0.08)" },
                borderBottom: { xs: "1px solid rgba(255,255,255,0.08)", md: "none" },
              }}
            >
              <Stack p={{ xs: 3, md: 4 }} gap={3} alignItems={{ xs: "center", md: "flex-start" }}>
                <Stack direction="row" alignItems="center" gap={0.5}>
                  <img
                    src={logo_2}
                    style={{ width: "90px", objectFit: "contain" }}
                    alt="Logo"
                  />
                  <Typography sx={{ color: themeOrange, fontSize: "32px", fontWeight: 800, lineHeight: 1 }}>
                    +
                  </Typography>
                </Stack>

                <Stack gap={0.5}>
                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.5)",
                      fontSize: "11px",
                      letterSpacing: "2px",
                      textTransform: "uppercase",
                      fontWeight: 600,
                    }}
                  >
                    Membership Benefit
                  </Typography>
                  <Typography sx={{ color: themeOrange, fontSize: "36px", fontWeight: 800, lineHeight: 1.15 }}>
                    Save $25
                  </Typography>
                  <Typography sx={{ color: "rgba(255,255,255,0.7)", fontSize: "16px", fontWeight: 500 }}>
                    on every Done job
                  </Typography>
                </Stack>
              </Stack>
            </Grid>

            {/* Middle — Features */}
            <Grid
              item
              xs={12}
              md={5}
              sx={{
                borderRight: { md: "1px solid rgba(255,255,255,0.08)" },
                borderBottom: { xs: "1px solid rgba(255,255,255,0.08)", md: "none" },
              }}
            >
              <Stack p={{ xs: 3, md: 4 }} gap={2.5} justifyContent="center" sx={{ height: "100%" }}>
                {[
                  { icon: dollar, text: "$10/month membership" },
                  { icon: jack, text: "Warranty extended from 30 to 60 days" },
                  { icon: calender_board, text: "Cancel anytime — no fees or penalties" },
                ].map((item, i) => (
                  <Stack key={i} direction="row" alignItems="center" gap={2}>
                    <Box
                      sx={{
                        width: 46,
                        height: 46,
                        borderRadius: "12px",
                        backgroundColor: "rgba(241,90,36,0.18)",
                        border: "1px solid rgba(241,90,36,0.3)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <img src={item.icon} style={{ width: "22px", height: "22px", objectFit: "contain" }} alt="" />
                    </Box>
                    <Typography sx={{ color: "white", fontSize: "15px", fontWeight: 500, lineHeight: 1.4 }}>
                      {item.text}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </Grid>

            {/* Right — CTA */}
            <Grid item xs={12} md={3}>
              <Stack p={{ xs: 3, md: 4 }} alignItems="center" justifyContent="center" sx={{ height: "100%" }} gap={2}>
                <ButtonComp
                  onClick={() =>
                    user?.subscription_id ? _handleCancel() : _handleNavigateMemberShip()
                  }
                  label={user?.subscription_id ? "Cancel Subscription" : "Subscribe Now"}
                  style={{
                    borderRadius: "12px",
                    background: user?.subscription_id
                      ? "rgba(255,255,255,0.08)"
                      : "linear-gradient(180deg, #F15A24 0%, #C53F10 100%)",
                    width: "100%",
                    border: user?.subscription_id ? "1px solid rgba(255,255,255,0.2)" : "none",
                    boxShadow: user?.subscription_id ? "none" : "0 6px 20px rgba(241,90,36,0.4)",
                  }}
                />
                {!user?.subscription_id && (
                  <Typography sx={{ color: "rgba(255,255,255,0.4)", fontSize: "12px", textAlign: "center" }}>
                    Cancel anytime. No commitment.
                  </Typography>
                )}

                {/* CANCEL SUBSCRIPTION MODAL */}
                <CustomModal
                  isOpen={isOpenModal}
                  setIsOpen={() => setIsOpenModal(!isOpenModal)}
                >
                  <Stack
                    sx={{ overflow: "auto", backgroundColor: "white", borderRadius: "16px" }}
                    alignItems={"center"}
                    p={1}
                  >
                    <Stack sx={{ width: "100%" }} alignItems={"flex-end"}>
                      <IconButton onClick={() => setIsOpenModal(!isOpenModal)}>
                        <RxCross2 size={20} />
                      </IconButton>
                    </Stack>
                    <Stack gap={2} px={3} pb={3} sx={{ width: "100%" }}>
                      <Typography sx={{ color: "#1a1a1a", fontSize: "18px", fontWeight: 700 }}>
                        Cancel Subscription?
                      </Typography>
                      <Typography sx={{ color: "#666", fontSize: "14px", lineHeight: 1.6 }}>
                        Are you sure you want to cancel your Done+ membership? You'll lose your $25 job discounts and extended warranty benefits.
                      </Typography>
                      <Stack gap={1.5} direction={"row"} alignItems={"center"} justifyContent={"flex-end"} mt={1}>
                        <ButtonComp
                          onClick={() => setIsOpenModal(!isOpenModal)}
                          label={"Keep Membership"}
                          style={{
                            width: "auto",
                            height: "auto",
                            borderRadius: "10px",
                            background: "linear-gradient(180deg, #F15A24 0%, #C53F10 100%)",
                          }}
                        />
                        <ButtonComp
                          onClick={_handleCancelSubscribe}
                          label={
                            cancelSubscribeLoader ? (
                              <CircularProgress size={22} sx={{ color: "#666" }} />
                            ) : (
                              "Yes, Cancel"
                            )
                          }
                          style={{
                            width: "auto",
                            height: "auto",
                            borderRadius: "10px",
                            background: "transparent",
                            color: "#666",
                            border: "1px solid #ddd",
                          }}
                        />
                      </Stack>
                    </Stack>
                  </Stack>
                </CustomModal>
              </Stack>
            </Grid>
          </Grid>

          {/* Terms footer */}
          <Box sx={{ borderTop: "1px solid rgba(255,255,255,0.08)", px: 4, py: 2 }}>
            <Typography sx={{ color: "rgba(255,255,255,0.4)", fontSize: "12px", textAlign: "center" }}>
              The $25 discount applies once per job. Done Member continue for $10/month until cancelled.{" "}
              <span
                onClick={() => navigate("/support")}
                style={{ color: "rgba(255,255,255,0.6)", cursor: "pointer", textDecoration: "underline" }}
              >
                Done Terms & Conditions.
              </span>
            </Typography>
          </Box>
        </Box>
      </Stack>

      {/* why membership -----!> */}
      <Stack my={2} mb={1}>
        <Typography className="mainHeading">Why Membership?</Typography>
      </Stack>

      <Grid container alignItems={"stretch"} spacing={3} mb={5}>
        {memberShipCardData.map(({ title, icon, description }, i) => (
          <Grid item xl={4} lg={4} md={4} sm={6} xs={12} key={i}>
            <Stack
              gap={2.5}
              sx={{
                borderRadius: "16px",
                backgroundColor: "white",
                border: "1px solid #f0f0f0",
                p: 3,
                height: "100%",
                position: "relative",
                overflow: "hidden",
                transition: "transform 0.25s ease, box-shadow 0.25s ease",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 16px 40px rgba(0,0,0,0.09)",
                },
              }}
            >
              {/* Top accent */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "3px",
                  background: "linear-gradient(90deg, #F15A24, #ff8c5a)",
                }}
              />
              <Box
                sx={{
                  width: 58,
                  height: 58,
                  borderRadius: "14px",
                  backgroundColor: "#FFF0EB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <img src={icon} style={{ width: "28px", height: "28px", objectFit: "contain" }} alt="" />
              </Box>
              <Typography sx={{ fontSize: "17px", fontWeight: 700, color: "#1a1a1a", lineHeight: 1.3 }}>
                {title}
              </Typography>
              <Typography sx={{ fontSize: "14px", color: "#777", lineHeight: 1.8 }}>
                {description}
              </Typography>
            </Stack>
          </Grid>
        ))}
      </Grid>

      {/* POPULAR SERVICES -----!> */}
      <Stack my={5}>
        <Stack
          alignItems={"center"}
          justifyContent={"space-between"}
          direction={"row"}
        >
          <Typography className="mainHeading">All Services</Typography>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            gap={2}
          >
            {/* --------!> BACKWARD BUTTON */}
            <Stack
              alignItems={"center"}
              justifyContent={"center"}
              sx={{
                height: "30px",
                width: "30px",
                borderRadius: "10px",
                backgroundColor: "white",
                boxShadow: "0px 0px 2px 0px grey",
                cursor: "pointer",
              }}
              onClick={_goToPrevSlide}
            >
              <MdOutlineKeyboardArrowLeft
                style={{ color: "black", fontSize: "25px" }}
              />
            </Stack>
            {/* --------!> FORWARD BUTTON */}
            <Stack
              alignItems={"center"}
              justifyContent={"center"}
              sx={{
                height: "30px",
                width: "30px",
                borderRadius: "10px",
                backgroundColor: "white",
                boxShadow: "0px 0px 2px 0px grey",
                cursor: "pointer",
              }}
              onClick={_goToNextSlide}
            >
              <MdOutlineKeyboardArrowRight
                style={{ color: "black", fontSize: "25px" }}
              />
            </Stack>
          </Stack>
        </Stack>

        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{
            width: "100%",
            borderRadius: "10px",
            backgroundColor: "white",
            boxShadow: "0px 0px 2px 0px grey",
            px: 1,
            py: 1,
            overflow: "auto",
            mt: 1,
          }}
          gap={1}
          className="slider_wrapper"
        >
          {/* CAROUSEL SLIDER -----!> */}
          <Swiper
            ref={swiperRef}
            slidesPerView={
              width >= 1100
                ? 5
                : width < 1100 && width > 900
                ? 3.8
                : width < 900 && width > 530
                ? 3
                : width < 530 && width > 460
                ? 2.5
                : width < 460 && width > 350
                ? 1.8
                : width < 350
                ? 1
                : 5
            }
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            className="mySwiper"
          >
            {get_all_services_data?.services?.map(
              ({ image, name, id, mobile_image, slug }) => {
                return (
                  <SwiperSlide key={id}>
                    <Stack
                      onClick={() => _handleClick(slug)}
                      alignItems={"center"}
                      justifyContent={"flex-start"}
                      sx={{
                        backgroundColor: "#F1F1F1",
                        borderRadius: "10px",
                        height: "130px",
                        width: "150px",
                        resize: "none",
                        flexShrink: "0",
                        overflow: "hidden",
                        cursor: "pointer",
                      }}
                      gap={1.5}
                      className="slider_item"
                    >
                      <Stack
                        sx={{
                          height: "70px",
                          width: "100%",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={getImageUrl(mobile_image)}
                          style={{
                            height: "100%",
                            width: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </Stack>
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: "700",
                          color: "black",
                        }}
                      >
                        {name || ""}
                      </Typography>
                    </Stack>
                  </SwiperSlide>
                );
              }
            )}
          </Swiper>
        </Stack>
      </Stack>
    </Container>
  );
};

export default Subscription;
